import { Dialog } from "@minuthq/meatball-ui-react"
import { useFormik } from "formik"

import { CreateTaskForm } from "src/components/TaskManagement/CreateTaskForm"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { usePostCreateTask } from "src/data/taskManagement/taskManagementQueries"
import { TTaskPostBody } from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"

const INITIAL_VALUE: TTaskPostBody = {
  title: "",
  home_id: "",
  category: "cleaning",
  description: "",
  status: "todo",
  assigned_to: {
    type: "user",
    assignee_id: "",
  },
  time_window: {
    due_date: "",
    earliest_start_date: undefined,
  },
}

const CREATE_TASK_FORM_ID = "create_task_form"

export function CreateTaskDialog({ onClose }: { onClose: () => void }) {
  const { tPlaceholder, t, langKeys } = useTranslate()
  const { orgId } = useOrganization()

  const postCreateTask = usePostCreateTask()

  const form = useFormik<typeof INITIAL_VALUE>({
    initialValues: INITIAL_VALUE,
    onSubmit: (values) => {
      postCreateTask.mutate(
        {
          path: { organization_id: orgId },
          body: { ...values },
        },
        {
          onSuccess: onClose,
        }
      )
    },
  })

  return (
    <Dialog
      open={true}
      onClose={onClose}
      title={tPlaceholder("Create new task")}
      confirmLabel={tPlaceholder("Create task")}
      formId={CREATE_TASK_FORM_ID}
      closeLabel={tPlaceholder("Cancel")}
      error={postCreateTask.isError && t(langKeys.failed_general_error_title)}
      loading={postCreateTask.isLoading}
    >
      <form
        id={CREATE_TASK_FORM_ID}
        onSubmit={(e) => {
          e.preventDefault()
          form.handleSubmit()
        }}
      >
        <CreateTaskForm form={form} />
      </form>
    </Dialog>
  )
}
